import React, { Component } from 'react';

import classNames from './../utils/classNames';

import Icon from './Icon';

const contains = (parentNode, childNode) => {
    if (!!parentNode.contains) {
        return parentNode.contains(childNode);
    }
    else {
        return parentNode.compareDocumentPosition(childNode) % 16;
    }
}

class Dropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };

        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.setOpen = this.setOpen.bind(this);
    }

    handleDocumentClick(event) {
        if (event.target === this.button || contains(this.button, event.target)) {
            return;
        }

        const ddAttr = event.target.getAttribute('data-dropdown');
        if (ddAttr === 'keep') {
            return;
        }
        if (ddAttr === 'close') {
            this.setState(state => Object.assign({}, state, { isOpen: false }));
            return;
        }
        const { closeAlways, keepOpen } = this.props;
        if (keepOpen) {
            return;
        }
        if (closeAlways || !contains(this.element, event.target)) {
            this.setState(state => Object.assign({}, state, { isOpen: false }));
        }
    }

    onButtonClick() {
        const { onButtonClick } = this.props;
        if (onButtonClick) {
            if (!onButtonClick()) {
                return;
            }
        }
        this.setState(state => Object.assign({}, state, {
            isOpen: !state.isOpen
        }));
    }

    setOpen() {
        this.setState(state => Object.assign({}, state, {
            isOpen: true
        }));
    }

    componentDidMount() {
        window.document.addEventListener('click', this.handleDocumentClick);
    }

    componentWillUnmount() {
        window.document.removeEventListener('click', this.handleDocumentClick)
    }

    render() {
        const { text, children, fluid, up, buttonClassName, icon, buttonId, title, hideArrow, disabled } = this.props;
        const { isOpen } = this.state;
        const btnClassName = buttonClassName || 'btn btn-block';

        const className = classNames('dropdown', { 'dropdown-fluid': fluid }, { 'dropdown-up': up })

        return (
            <div className={className} ref={element => this.element = element}>
                <button type="button" className={btnClassName} onClick={this.onButtonClick} ref={element => this.button = element} id={buttonId} title={title} disabled={disabled}>
                    {!!icon && <Icon className="svg-icon" iconName={icon} />} {text}
                    {!hideArrow &&
                        <span className="arrow-down"></span>
                    }
                </button>
                {isOpen &&
                    <div className="dropdown-content">
                        {children}
                    </div>
                }
            </div>
        );
    };
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Dropdown.js